// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c2e45c07","239":"8ecb5e88","455":"d935d962"}[chunkId] + ".chunk.js";
};